import React from "react";

const Search = () => {
  return (
    <div className="w-[226px] h-[44px] relative border-[0.5px] border-[#DEE2F3] outline-none rounded">
      <input type="search" placeholder="Enter reference ID" className="w-full placeholder:text-[#69708D] rounded focus:outline-none h-full border-none outline-none pl-[40px]"/>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-search w-[19px] h-[19px] absolute top-[14.5px] left-[13px] text-[#69708D]"
        viewBox="0 0 16 16"
      >
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
      </svg>
    </div>
  );
};

export default Search;
